export default /* glsl */`
#ifdef USE_MAP

	uniform vec3 color0;
	uniform vec3 color1;
	uniform float tintInfluence;

#endif
`;
